import React from 'react';
import styled from 'styled-components';
import { VerticalNavigation, VerticalNavigationElement } from '@increasecard/typed-components';
import { Link as RouterLink } from 'react-router-dom';

const LeftColumnStyled = styled.div`
  width: 244px;
  min-width: 244px;
  background: #fff;
  box-shadow: 0px 3px 9px rgba(24, 32, 38, 0.18);
  padding: 48px 0 48px 26px;
  display: flex;
  flex-direction: column;
  @media (max-width: 640px) {
    & {
      display: none;
    }
  }
`;

type Link = {
  label: string;
  href: string;
  active: boolean;
};

type LeftColumnProps = {
  links: Link[];
};

const VerticalNavigationLink = styled(VerticalNavigationElement).attrs({ as: RouterLink })`
  ${({ theme }) => theme.typography.body}
  display: flex;
  align-items: center;

  :not(:first-child) {
    margin-top: 24px;
  }
`;

const LeftColumn = ({ links }: LeftColumnProps) => {
  return (
    <LeftColumnStyled>
      <VerticalNavigation>
        {links.map((link, index) => {
          return (
            link.label !== '' && (
              <VerticalNavigationLink active={link.active ? 1 : 0} key={index} to={link.href}>
                {link.label}
              </VerticalNavigationLink>
            )
          );
        })}
      </VerticalNavigation>
    </LeftColumnStyled>
  );
};

export default LeftColumn;
